/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Err_Number_InvalidInputs */

const vi_einvoice_err_number_invalid = /** @type {(inputs: Einvoice_Err_Number_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số hóa đơn chỉ gồm chữ số, tối đa 8 chữ số`)
};

/**

* @param {Einvoice_Err_Number_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_err_number_invalid = /** @type {((inputs?: Einvoice_Err_Number_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Err_Number_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_err_number_invalid(inputs)
});